import { makeStyles } from '@material-ui/core/styles';
export default makeStyles(function () {
  return {
    root: {
      opacity: 1
    }
  };
}, {
  name: 'text-helper-visible'
});